import React from 'react';
import { Link } from 'react-router-dom';

class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggle: false,
    };
    this.toggleVisibility = this.toggleVisibility.bind(this);
    this.closeNavbar = this.closeNavbar.bind(this);
  }

  toggleVisibility() {
    this.setState((state) => ({
      toggle: !state.toggle,
    }));
  }

  closeNavbar() {
    this.setState(() => ({
      toggle: false,
    }));
  }

  render() {
    const { toggle } = this.state;
    return (
      <div className="Navbar">
        <nav className="desktopnav desktopshow">
          <h2><Link to="/">Nemwel</Link></h2>
          <ul>
            <li><Link id="AboutMe-link" to="/#AboutMe">About Me</Link></li>
            <li><Link id="services-link" to="/#services">Services</Link></li>
            <li><Link id="portfolio-link" to="/#portfolio">Portfolio</Link></li>
            <li><Link id="testimonials-link" to="/#testimonials">Testimonials</Link></li>
            <li><Link id="blogs-link" to="/#blogs">Blogs</Link></li>
            <li><Link id="contact-link" to="/#contact">Contact Me</Link></li>
            <li><Link id="resume-link" to="/resume">Resume</Link></li>
          </ul>
        </nav>
        <nav className="mobilenav mobileshow">
          <div className="navheading">
            <h2><Link to="/">Nemwel</Link></h2>
            <button
              onClick={this.toggleVisibility}
              type="button"
              aria-label="Toggle navigation menu"
              aria-expanded={toggle}
              aria-controls="mobile-menu"
            >
              <i className="fa fa-bars" aria-hidden="true" />
            </button>
          </div>
          {toggle ? (
            <div className="toggleshow" id="mobile-menu">
              <ul>
                <li><Link id="AboutMe-link-mobile" onClick={this.closeNavbar} to="/#AboutMe">About Me</Link></li>
                <li><Link id="services-link-mobile" onClick={this.closeNavbar} to="/#services">Services</Link></li>
                <li><Link id="portfolio-link-mobile" onClick={this.closeNavbar} to="/#portfolio">Portfolio</Link></li>
                <li><Link id="testimonials-link-mobile" onClick={this.closeNavbar} to="/#testimonials">Testimonials</Link></li>
                <li><Link id="blogs-link-mobile" onClick={this.closeNavbar} to="/#blogs">Blogs</Link></li>
                <li><Link id="contact-link-mobile" onClick={this.closeNavbar} to="/#contact">Contact Me</Link></li>
                <li><Link id="resume-link-mobile" onClick={this.closeNavbar} to="/resume">Resume</Link></li>
              </ul>
            </div>
          ) : ''}
        </nav>
      </div>
    );
  }
}

export default Navbar;
